import * as types from '../types'

/**
 * 农友列表及详情
 * list: 农友列表
 * detail: 农友详情
 * @type {Object}
 */
const state = {
    list: [],
    detail: {}
}

const getters = {

}

const mutations = {
    [types.INIT_FARMER_LIST] (state, arr) {
        state.list = arr
    },

    [types.AJAX_UPDATE_FARMER_LIST] (state, arr) {
        state.list = state.list.concat(arr)
    },

    [types.INIT_FARMER_DETAIL] (state, params) {
        state.detail = params
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/farmer.js